// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-empty-state{display:flex;height:100%;width:100%;align-items:center;justify-content:center}.ac-empty-state__title{font-family:\"Montserrat\";text-transform:uppercase}\n", ""]);
// Exports
module.exports = exports;
